<template>
  <v-container grid-list-md>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="400px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{ attrs }">
        <v-btn
          fab
          color="success"
          dark
          v-bind="attrs"
          @click.stop="dialog = true"
        >
          <v-icon>fas fa-plus-circle</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          NEW QAAS
          <v-spacer></v-spacer>
          <v-btn text icon @click.stop="close">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="form" v-model="valid" class="mx-5">
          <v-text-field
            outlined
            v-model.trim="QaasInfo.FullName"
            validate-on-blur
            :rules="[v => !!v || 'Full Name is required']"
            label="Full Name"
            color="success"
            prepend-inner-icon="fas fa-user-tie"
            required
          >
          </v-text-field>
          <v-text-field
            outlined
            v-model.number="QaasInfo.Qphone"
            validate-on-blur
            :rules="[v => !!v || 'Phone is required', minlength]"
            label="Phone"
            color="success"
            type="number"
            prepend-inner-icon="fas fa-phone-alt"
            required
          >
          </v-text-field>

          <v-text-field
            outlined
            v-model.trim="QaasInfo.IDNomber"
            validate-on-blur
            :rules="[v => !!v || 'Passport or other ID is required']"
            label="ID Number"
            color="success"
            prepend-inner-icon="fas fa-address-card"
            required
          >
          </v-text-field>
          <BaseNumInput
            outlined
            label="Limit Amount"
            v-model.number="QaasInfo.limit"
          ></BaseNumInput>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn
              color="success"
              class="mb-5"
              width="200px"
              :loading="clicked"
              @click="OnSaveCustomer"
            >
              Register
              <v-icon right>fas fa-plus</v-icon>
            </v-btn>
          </v-card-actions>
        </v-form>
        <p v-if="ErrorMsg" class="red--text d-flex mt-2 justify-center">
          {{ ErrorMsg }}
        </p>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  props: {
    BaseURL: { type: String, required: true },
    loadFunction: { type: Function, required: true },
  },
  data() {
    return {
      dialog: false,
      clicked: false,
      valid: true,
      date: null,
      ErrorMsg: "",
      QaasInfo: {
        FullName: null,
        Qphone: null,
        IDNomber: null,
        limit: 0,
      },
    };
  },

  computed: {},
  methods: {
    close() {
      // console.log("colosed");
      this.dialog = false;
      this.$refs.form.reset();
      this.loadFunction();
    },
    isGreaterthanZero(v) {
      return v.toString().replace(/,/g, "") > 0 || "Monthly Amount is required";
    },
    isNumber(v) {
      if (v && isNaN(v)) return "Phone must be a number";
      else return false;
    },
    minlength(v) {
      if (!v) return "Required phone";
      return (
        v.toString().length > 8 || "Phone length must be at least 9 number"
      );
    },
    OnSaveCustomer() {
      this.ErrorMsg = "";

      if (this.$refs.form.validate()) {
        this.clicked = true;
        this.QaasInfo.date = this.Current().date;

        this.$store
          .dispatch("INSERT_ONLY", {
            url: this.BaseURL,
            data: this.QaasInfo,
          })
          .then(() => {
            this.loadFunction();
            this.$refs.form.reset();
            this.clicked = false;
            // console.log(result);
          })
          .catch(err => {
            this.clicked = false;
            // console.log(err.response);
            if (err.response.status === 400) this.ErrorMsg = err.response.data;
            if (err.response.status === 409)
              this.ErrorMsg = this.QaasInfo.Qphone + " is registred";
            else this.ErrorMsg = err.response.data;
          });
      }
    },
  },
};
</script>
